module.exports = __webpack_public_path__ + "img/logo.354d9ad1.png";